import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent the browser from trying to automatically restore the scroll position,
    // which can conflict with our manual reset when a user clicks a link from the bottom of the page.
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      // Force multiple scroll targets to cover different layout-structures and browsers
      window.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
      document.body.scrollTo(0, 0);
    };

    // Scroll immediately
    scrollToTop();

    // Use a micro-delay fallback to handle asynchronous layout shifts, Recharts mounting, or Markdown rendering
    const timeoutId = setTimeout(scrollToTop, 25);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
}
